import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button } from '@material-ui/core'

class CsvDownload extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    valueFormatter: PropTypes.func,
  }

  static defaultProps = {
    valueFormatter: (v) => (v),
  }

  format = (k, v) => {
    switch (k) {
      case 'timestamp':
        return moment(v).local().format('LLL')
      default:
        return this.props.valueFormatter(v)
    }
  }

  csv() {
    const { data } = this.props
    let csvContent = 'data:text/csv;charset=utf-8,'

    // Header row
    csvContent += `${Object.keys(data[0]).join(',')}\n`

    // Content
    csvContent += data.map((item) => (
      Object.entries(item).map(([k, val]) => (
        `"${this.format(k, val)}"`
      )).join(',')
    )).join('\n')

    return csvContent
  }

  render() {
    const { data, valueFormatter, ...props } = this.props
    const csv = encodeURI(this.csv())
    return (
      <Button href={csv} download="data.csv" {...props}>Download</Button>
    )
  }
}

export default CsvDownload
